// extracted by mini-css-extract-plugin
export default {"cta":"GJ-z","disabled":"HJ-z"};